<template>
  <b-modal
    id="bv-modal-add-linked-starts"
    title="Добавить старт в серию"
    hide-footer
  >
    <div v-if="allSeries.length">
      <b-list-group>
        <b-list-group-item
          v-for="serie in allSeries"
          :key="serie.id"
          class="d-flex justify-content-between align-items-center"
        >
          <div>
            <h6 class="mb-1">
              {{ serie.name }}
            </h6>
            <small class="text-muted">{{ serie.description }}</small>
          </div>
          <div>
            <b-badge
              variant="info"
              class="mr-2"
            >
              {{ serie.starts.length }} старт(ов)
            </b-badge>
            <b-button
              size="sm"
              variant="primary"
              @click="addToSerie(serie)"
            >
              Добавить
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>

    <div
      v-else
      class="text-center text-muted"
    >
      Нет доступных серий
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'DistanceModalAddLinkedStarts',
  components: {
    BModal, BListGroup, BListGroupItem, BButton, BBadge,
  },
  props: {
    allSeries: {
      type: Array,
      default: () => [],
    },
    startId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async addToSerie(serie) {
      try {
        const payload = {
          startIds: [...serie.starts.map(s => s.id), this.startId],
        }

        const response = await this.$http.put(
          'start/start-series/change-serie',
          payload,
          { params: { id: serie.id } },
        )

        this.$bvToast.toast(`Старт успешно добавлен в серию "${serie.name}"`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
        this.$emit('start-added')
      } catch (error) {
        console.error('Ошибка при добавлении старта в серию:', error)
        if (error.response) {
          console.error('Статус:', error.response.status)
          console.error('Ответ:', error.response.data)
        } else {
          console.error('Ошибка без ответа:', error.message)
        }

        this.$bvToast.toast('Ошибка при добавлении старта в серию', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style scoped>
.list-group-item:focus {
  background-color: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
